// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0c281cd9","513":"29a143f7","703":"5ec14ccd","787":"8660e7d1"}[chunkId] + ".chunk.js";
};